export default "__VITE_ASSET__q5aUT_uW__"